module.exports = __webpack_public_path__ + "static/media/wordLogo.021675c8.jpeg";